import React from "react";

const PageIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" />
    <path
      d="M24 14v14"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="24" cy="34" r="1.75" fill="currentColor" />
  </svg>
);

export function RenderErrorFallback({
  title = "This page couldn't be loaded",
  message,
  variant = "inline",
}) {
  if (variant === "page") {
    return (
      <section className="ls-render-error-page" role="alert">
        <div className="ls-render-error-page__inner">
          <div className="ls-render-error-page__icon">
            <PageIcon />
          </div>
          <h1 className="ls-render-error-page__title">{title}</h1>
          {message ? (
            <p className="ls-render-error-page__message">{message}</p>
          ) : null}
        </div>
      </section>
    );
  }

  return (
    <div className="ls-error-boundary-fallback ls-error-boundary-fallback--inline">
      {message || title}
    </div>
  );
}
